<script>
    import _ from 'lodash';
    import {navigate} from 'svelte-routing';
    import {store, api, api_formdata} from '../stores.js';
    import LoadingCard from '../components/LoadingCard.svelte';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import Header from '../components/Header.svelte';
    
    const user = store('credentials', 'appUserAuth');
    
    // form data
    let login = ($user.email ? $user.email : ''),
        password = ($user.pasport ? $user.pasport : ''),
        name = '',
        datePlan = '',
        timePlan = '',
        price = '',
        otherScan = '',
        fileSummary = '',
        komment = '',
        produkt = '',
        mest = '',
        gorod = ($user.gorod ? $user.gorod : ''),
        adres = '',
        start = true;
    
    let files = [];
    
    export let id = '';

    // если редактирование события
    const fetchEvent = (async () => {
        if (id) {
            let result = await api('getEvent', {idEvent: id});
    
            name = result.data.name.replaceAll('&quot;', '"');
            datePlan = result.data.datePlan;
            timePlan = result.data.timePlan;
            price = result.data.price;
            komment = result.data.komment;
            produkt = result.data.idProd;
            mest = result.data.mest;
            gorod = result.data.gorod;
            adres = result.data.adres;
            start = +result.data.start;
    
            files = result.data.fileSummary.split(',');
    
            return result.data ? result.data : [];
        }
        
        return [];
    })();

    const fetchProductList = (async () => {
        let result = await api('getProductList', {login: $user.email, password: $user.pasport});
        return result.data ? result.data : [];
    })();
    
    const handlerSaveClick = async (e) => {
        let label = e.target.innerText;
        let popup = new bootstrap.Modal(document.getElementById('form-saved'));
    
        if (login && password && mest > 0) {
            let ev = await fetchEvent;
            let fd = new FormData();
                fd.append('id', id);
                fd.append('login', login);
                fd.append('password', password);
                fd.append('name', name);
                fd.append('datePlan', datePlan);
                fd.append('timePlan', timePlan);
                fd.append('price', price);
                fd.append('komment', komment);
                fd.append('produkt', produkt);
                fd.append('mest', mest);
                fd.append('gorod', gorod);
                fd.append('adres', adres);
                fd.append('actualnost', 1);
                fd.append('start', start ? 1 : 0);
                
            if (otherScan && otherScan[0]) {
                fd.append('files[otherScan]', otherScan[0]);
            } else {
                if (ev.otherScan) {
                    fd.append('otherScan', ev.otherScan);
                }
            }
    
            // указываем оставшиеся файлы и догружаем выбранные
            fd.append('fileSummary', files.join(','));
            for (let x = 0; x < fileSummary.length; x++) {
                fd.append('files[fileSummary][]', fileSummary[x]);
            }

            e.target.innerText = 'Сохранение...';
            await api_formdata(id ? 'editEvent' : 'addNewEvent', fd);
            e.target.innerText = label;
            
            popup.show();
            setTimeout(() => {
                popup.hide();
                navigate(id ? '/activity/view/' + id : '/activity');
            }, 2500);
        }
    };

    const handlerRemoveFile = (i) => {
        files = [...files.filter((it, inx) => inx !== i)];
    };

    const handlerRemoveBtnClick = () => {
        (new bootstrap.Modal(document.getElementById('event-remove'))).show();
    };

    const handlerRemoveEvent = async () => {
        if (id) {
            let ev = await fetchEvent;
            
            if (login && password) {
                await api('editEvent', {
                    login, password, id,
                    name: ev.name,
                    datePlan: ev.datePlan,
                    timePlan: ev.timePlan,
                    price: ev.price,
                    otherScan: ev.otherScan,
                    komment: ev.komment,
                    produkt: ev.idProd,
                    mest: ev.mest,
                    adres: ev.adres,
                    actualnost: 0
                });
                
                navigate('/activity');
            }
        }
    };
</script>

<TopMenu title="{(id ? 'Редактирование' : 'Добавление')}">
    <TopMenu_BackBtn slot="back" href="{(id ? '/activity/view/' + id : '/activity')}" />
    <button slot="remove" type="button" class="btn btn-link btn-icon" style="{id ? '' : 'display:none'}" on:click={handlerRemoveBtnClick}>
        <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
    </button>
</TopMenu>

<div id="appCapsule">
    <Header title="{(id ? 'Редактирование' : 'Новое')} " />
    
    {#await fetchEvent}
        <LoadingCard />
    {:then data}
        <div class="section mt-1 mb-5">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <h5 class="mb-3 font-weight-bold">Основная информация</h5>
                    
                                    <div class="row">
                                        <div class="col-8">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label class="form-label" for="produkt">Продукт <span class="text-danger">*</span></label>
                                                    {#await fetchProductList}
                                                        <select class="form-control form-select">
                                                            <option value="null" selected disabled>Загрузка</option>
                                                        </select>
                                                    {:then data}
                                                        <select class="form-control form-select" id="produkt" name="produkt" bind:value={produkt} required>
                                                            {#each data as {idProd, naimenovanie, idRegPred}}
                                                                <option value="{idProd}" disabled="{(idRegPred > 0 ? 0 : 1)}">{naimenovanie}</option>
                                                            {/each}
                                                        </select>
                                                    {/await}
                                                </div>
                                            </div>
                                        </div>
    
                                        <div class="col-4">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper text-center">
                                                    <label class="form-label"  for="switch-start">Старт мероприятия</label>
                                                    <div class="form-check form-switch d-inline-block">
                                                        <input class="form-check-input" type="checkbox" id="switch-start" bind:checked={start} on:click={() => {start = !start}}>
                                                        <label class="form-check-label" for="switch-start"></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="name">Название <span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" id="name" name="name" placeholder="Тренинг .." bind:value={name} required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="datePlan">Дата проведения <span class="text-danger">*</span></label>
                                                    <input type="date" class="form-control" id="datePlan" name="datePlan" bind:value={datePlan} required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="timePlan">Время проведения <span class="text-danger">*</span></label>
                                                    <input type="time" class="form-control" id="timePlan" name="timePlan" bind:value={timePlan} required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <!--<div class="col-6">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="price">Стоимость</label>
                                                    <input type="number" class="form-control" id="price" name="price" bind:value={price}>
                                                </div>
                                            </div>
                                        </div>-->
                                        <div class="col-6">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="mest">Количество мест <span class="text-danger">*</span></label>
                                                    <input type="number" class="form-control" id="mest" name="mest" bind:value={mest}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                    
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="adres">Адрес</label>
                                                    <textarea name="adres" id="adres" class="form-control" style="min-height:70px" bind:value={adres}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="form-group boxed">
                                                <div class="input-wrapper">
                                                    <label for="komment">Комментарий</label>
                                                    <textarea name="komment" id="komment" class="form-control" style="min-height:70px" bind:value={komment}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!--Картинка-->
                        <div class="card-body pt-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="custom-file-upload" id="fileUpload1" style="{(data.otherScan ? 'height: 182px;' : 'height: 100px;')}">
                                        <input type="file" id="otherScan" name="files[otherScan]" accept=".png, .jpg, .jpeg" bind:files={otherScan}>
            
                                        <label for="otherScan" style="{(data.otherScan ? `background: url('https://225304.selcdn.ru/miin/${data.otherScan}') no-repeat center center; background-size: cover` : '')}">
                                            <span>
                                                <strong>
                                                    <ion-icon name="cloud-upload-outline" role="img" class="md hydrated" aria-label="Картинка"></ion-icon>
                                                    <i>
                                                        {#if otherScan && otherScan[0]}
                                                            {otherScan[0].name}
                                                        {:else if data.otherScan}
                                                            {data.otherScan}
                                                        {:else}
                                                            Загрузить картинку
                                                        {/if}
                                                    </i>
                                                </strong>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!--Материалы-->
                        <div class="card-body pt-0">
                            <div class="row">
                                <div class="col-12 pt-1">
                                    {#if files.length > 0}
                                        <div class="listview-title">Загруженные файлы</div>
                                        <ul class="listview image-listview mb-2">
                                            {#each files as url, i}
                                                <li>
                                                    <div class="item">
                                                        <div class="in">
                                                            <div class="col-8 overflow-hidden text-nowrap">{url}</div>
                                                            <span class="col-4 d-flex justify-content-end">
                                                                <a href="https://225304.selcdn.ru/miin/{url}" download="{url}" class="btn btn-secondary btn-sm btn-icon" style="margin-right: 5px;">
                                                                    <ion-icon name="cloud-download-outline" role="img" class="md hydrated" aria-label="download"></ion-icon>
                                                                </a>
                                                                <button type="button" class="btn btn-danger btn-sm btn-icon" on:click={() => handlerRemoveFile(i)}>
                                                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="remove"></ion-icon>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                            {/each}
                                        </ul>
                                    {/if}
                                </div>
    
                                <div class="col-12">
                                    <div class="custom-file-upload" id="fileUpload2">
                                        <input type="file" id="fileSummary" name="files[fileSummary][]" accept=".png, .jpg, .jpeg, .pdf, .ppt, .pptx" multiple="multiple" bind:files={fileSummary}>
            
                                        <label for="fileSummary">
                                            <span>
                                                <strong>
                                                    <ion-icon name="cloud-upload-outline" role="img" class="md hydrated" aria-label="Файлы"></ion-icon>
                                                    <i>
                                                        {#if fileSummary}
                                                            {@html _.map(fileSummary, (el) => el.name).join('<br>')}
                                                        {:else}
                                                            Загрузить материалы
                                                        {/if}
                                                    </i>
                                                </strong>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-footer">
                            <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerSaveClick}>{(id ? 'Сохранить' : 'Добавить')}</button>
                        </div>
                        
                        <div class="modal fade dialogbox" id="form-saved" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-icon text-success">
                                        <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                                    </div>
                                    <div class="modal-header">
                                        <h5 class="modal-title">{(id ? 'Сохранено' : 'Добавлено')}</h5>
                                    </div>
                                    <div class="modal-footer">
                                        <div class="btn-inline">
                                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                
                        <!-- Dialog Event Remove -->
                        <div class="modal fade dialogbox" id="event-remove" data-bs-backdrop="static" tabindex="-1" role="dialog">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Вы уверены?</h5>
                                    </div>
                                    <div class="modal-body">
                                        Это действие приведёт<br>
                                        к удалению мероприятия
                                    </div>
                                    <div class="modal-footer">
                                        <div class="btn-inline">
                                            <button type="button" class="btn btn-text-danger" data-bs-dismiss="modal" on:click={handlerRemoveEvent}>
                                                <ion-icon name="trash-outline"></ion-icon>
                                                Удалить
                                            </button>
                                            <button type="button" class="btn" data-bs-dismiss="modal">
                                                <ion-icon name="ban-outline"></ion-icon>
                                                Отмена
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- * Dialog Event Remove -->
                    </div>
                </div>
            </div>
        </div>
    {/await}
</div>
